import { render, staticRenderFns } from "./MenuMonitorComitente.vue?vue&type=template&id=537a9060&scoped=true&"
import script from "./MenuMonitorComitente.vue?vue&type=script&lang=js&"
export * from "./MenuMonitorComitente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a9060",
  null
  
)

export default component.exports